import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import { Body, H5 } from 'syf-component-library/ui/typography';
import colors from '../../../../../const/colors';
export const HeaderWrapper = styled(Inset) `
  background-color: ${colors.turquoise};
`;
export const HeaderContainer = styled.div `
  display: flex;
  width: 100%;

  @media ${query.lessThanMedium} {
    flex-direction: column;
    align-items: center;
  }
`;
export const Image = styled.img `
  height: 96px;
  width: 144px;
  max-width: 190px;

  @media ${query.lessThanMedium} {
    height: 64px;
    width: 96px;
    max-width: 96px;
  }
`;
export const HeaderContent = styled(Inset) `
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${query.lessThanMedium} {
    align-content: center;
  }
`;
export const Title = styled(H5) `
  text-align: left;

  @media ${query.lessThanMedium} {
    text-align: center;
    font-size: 20px;
  }
`;
export const SubTitle = styled(Body) `
  text-align: left;

  @media ${query.lessThanMedium} {
    text-align: center;
  }
`;
